import { render } from "./MQueryAccount.vue?vue&type=template&id=5cc21978&scoped=true"
import script from "./MQueryAccount.vue?vue&type=script&lang=js"
export * from "./MQueryAccount.vue?vue&type=script&lang=js"

import "./MQueryAccount.vue?vue&type=style&index=0&id=5cc21978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc21978"]])

export default __exports__